async function CopyDesign(designid, userid, node, copytodesignid) {

    if (designid.length > 0 && userid.length > 0) {

        let response;

        response = await fetch("https://api.cssi.co/CNF/CopyDesign", {
            method: "POST",
            body: JSON.stringify(
                {
                    "designid": designid,
                    "userid": userid,
                    "node": node,
                    "copyToDesignId": copytodesignid
                }
            )
        })
            .then(response => {
                return response.json();
            })
            .catch(e => {
                e.name === "AbortError" ? console.log("Fetch Aborted") : console.log(e.message);
            })
        return Promise.resolve(response);
    }
}

export default CopyDesign;